import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellStageCard.title',
    defaultMessage: 'Try our Compliance Stage',
  },
  subtitle: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellStageCard.subtitle',
    defaultMessage: 'And automate your document review!',
  },
  discover: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellStageCard.discover',
    defaultMessage: 'Discover',
  },
  // Seeds the Cue conversation. It names the workflow and stage the recruiter is
  // looking at so the agent doesn't have to ask which one, and then leaves the
  // procedure to the agent — it owns the matching, the consent step, and the
  // workflow transformation itself.
  //
  // The `entryPoint` line is the only signal the agent gets that this came from
  // the banner rather than a recruiter typing: `openMethod` on dispatchOpenCue
  // is analytics-only (it reaches PostHog as `sent_from`, never the model), so
  // the trigger has to travel in the message text. The agent prompt branches on
  // this to open with the pitch rather than the normal working order.
  //
  // The card passes `hideMessage`, which keeps this out of the chat on the click
  // itself. It does not keep it out of the recruiter's view: the text is
  // persisted as an ordinary user message, so it renders in the chat-history
  // sidebar immediately and as a user bubble on the next thread load. See
  // `OpenCuePayload.hidden` in shared/dispatch-copilot-command.ts.
  //
  // So the `entryPoint` line is copy the recruiter can end up reading. It stays
  // in the message because nothing else carries the trigger to the model, and it
  // stays terse and unalarming for the same reason.
  discoverCuePrompt: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellStageCard.discoverCuePrompt',
    defaultMessage:
      'entryPoint: compliance_upsell_banner\n\nSet up compliance on the "{openingTitle}" workflow, starting from the "{stageTitle}" stage.',
  },
  dismissAriaLabel: {
    id: 'app.containers.WorkflowEditor.components.StageColumn.ComplianceUpsellStageCard.dismissAriaLabel',
    defaultMessage: 'Dismiss',
  },
});
